<template>
  <div class="my-center-container main_sm">
    <!-- 包裹容器 -->
    <div class="container">
      <!-- 个人中心-左边 -->
      <div class="container-left">
        <!-- 个人头像 -->
        <div v-if="$store.state.userInfo" class="head-portrait common">
          <!-- 头像 -->
          <div class="head_img">
            <img alt="" :src="$store.state.userInfo.headpic" />
          </div>
          <!-- 标题 -->
          <div class="title">
            <h3>
              {{ $store.state.userInfo.nickname }}
            </h3>
            <!-- <p>学号：234567822</p> -->
          </div>
        </div>
        <!-- 导航栏 -->
        <div class="tab-content">
          <!-- 上tab -->
          <div class="tab-top common">
            <div
              class="cell"
              :class="{ bgactive: $route.path === '/myCourses' }"
              @click="goCenterPage('/myCourses')"
            >
              <icon-svg
                class="cell-block"
                :icon-class="
                  'icon_kecheng_' + ($route.path === '/myCourses' ? '1' : '0')
                "
              />
              <span>我的课程</span>
            </div>
            <div
              class="cell"
              :class="{ bgactive: $route.path === '/mySchedule' }"
              @click="goCenterPage('/mySchedule')"
            >
              <icon-svg
                class="cell-block"
                :icon-class="
                  'icon_kebiao_' + ($route.path === '/mySchedule' ? '1' : '0')
                "
              />
              <span>我的课表</span>
            </div>
            <div
              class="cell"
              :class="{ bgactive: $route.path === '/myTask' }"
              @click="goCenterPage('/myTask')"
            >
              <icon-svg
                class="cell-block"
                :icon-class="
                  'icon_bangzhu_' + ($route.path === '/myTask' ? '1' : '0')
                "
              />
              <span>我的作业</span>
            </div>
          </div>
          <!-- 中tab -->
          <div class="tab-middle common">
            <div
              class="cell"
              :class="{ bgactive: $route.path === '/orderCenter' }"
              @click="goCenterPage('/orderCenter')"
            >
              <icon-svg
                class="cell-block"
                :icon-class="
                  'icon_dingdan_' + ($route.path === '/orderCenter' ? '1' : '0')
                "
              />
              <span>订单中心</span>
            </div>
            <div
              class="cell cell-b"
              :class="{ bgactive: $route.path === '/myService' }"
              @click="goCenterPage('/myService')"
            >
              <icon-svg
                class="cell-block"
                :icon-class="
                  'icon_fuwu_' + ($route.path === '/myService' ? '1' : '0')
                "
              />
              <span>我的服务</span>
            </div>
            <div
              class="cell"
              :class="{ bgactive: $route.path === '/discountCoupon' }"
              @click="goCenterPage('/discountCoupon')"
            >
              <icon-svg
                class="cell-block"
                :icon-class="
                  'icon_youhui_' +
                  ($route.path === '/discountCoupon' ? '1' : '0')
                "
              />
              <span>优惠券</span>
            </div>
          </div>
          <!-- 下tab -->
          <div class="tab-bottom common">
            <!-- <div
              class="cell"
              @click="goCenterPage('/userHelpCenter')"
              :class="{ bgactive: $route.path === '/userHelpCenter' }"
            >
              <icon-svg
                class="cell-block"
                :icon-class="
                  'icon_bangzhu_' +
                  ($route.path === '/userHelpCenter' ? '1' : '0')
                "
              />
              <span>帮助中心</span>
            </div> -->
            <div
              class="cell"
              :class="{ bgactive: $route.path === '/accountSetting' }"
              @click="goCenterPage('/accountSetting')"
            >
              <icon-svg
                class="cell-block"
                :icon-class="
                  'icon_shezhi_' +
                  ($route.path === '/accountSetting' ? '1' : '0')
                "
              />
              <span>账户设置</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 个人中心-右边 -->
      <div class="contarner-right common">
        <div class="contarner-header">
          <h3>{{ $route.meta.title }}</h3>
        </div>
        <div class="routerContent"><router-view /></div>
      </div>
    </div>
  </div>
</template>
<script>
// import { getMyCenter } from '@/network/request'
export default {
  name: 'Mycenter',
  data() {
    return {}
  },
  created() {},
  methods: {
    goCenterPage(path) {
      this.$router.push(path)
    },
  },
}
</script>
<style lang="scss" scoped>
@m_top: 12px;
@fz: 18px;
.my-center-container {
  margin-top: 50px;
  margin-bottom: 50px;
  // 公共
  .common {
    width: 100%;
    border-radius: 10px;
    border: 1px solid #efefef;
    background-color: #fff;
  }
  // 盒子居中
  .center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .container {
    border-radius: 10px;
    overflow: hidden;
    // 左
    .container-left {
      float: left;
      width: 240px;
      // 头像
      .head-portrait {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 220px;
        .head_img {
          width: 80px;
          height: 80px;
          border: solid 4px #ffffff;
          border-radius: 50%;
          // background-color: #002233;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          img {
            display: block;
            width: 100%;
          }
        }
        .title {
          margin-top: 15px;
          h3 {
            font-size: 20px;
            color: #000000;
          }
          p {
            margin-top: 5px;
            font-size: 16px;
            color: #999999;
          }
        }
      }
      // 上
      .tab-top {
        margin-top: 12px;
      }
      // 中
      .tab-middle {
        margin-top: 12px;
      }
      // 下
      .tab-bottom {
        margin-top: 12px;
      }
    }
    // 右
    .contarner-right {
      position: relative;
      float: right;
      width: 794px;
      min-height: 700px;

      .contarner-header {
        background-color: rgba(250, 251, 252, 0.5);
        padding: 20px;
        border-bottom: 1px solid #f2f2f2;
        h3 {
          font-size: 20px;
          font-weight: normal;
          color: #000000;
        }
      }
    }
  }
  .cell {
    display: flex;
    align-items: center;
    padding: 25px 0 25px 20px;
    border-bottom: 1px solid #efefef;
    cursor: pointer;
    span {
      font-size: 16px;
    }
    .cell-block {
      display: inline-block;
      vertical-align: middle;
      font-size: 20px;
      margin-right: 8px;
    }

    &:last-child {
      border-bottom: none;
    }
  }
  .bgactive {
    color: #419cff;
  }

  .cell-b {
    border-bottom: 1px solid #efefef;
  }
}
</style>
